import Typography from 'typography'
import theme from 'typography-theme-bootstrap'

theme.googleFonts = [
  {
    name: 'Lora',
    styles: ['400', '500', '700'],
  },
  {
    name: 'Raleway',
    styles: ['400', '400i', '700', '700i'],
  },
]

theme.headerFontFamily = ['Lora'].concat(theme.headerFontFamily)
theme.bodyFontFamily = ['Raleway'].concat(theme.bodyFontFamily)
theme.baseFontSize = '18px'

const typography = new Typography(theme)
const { rhythm, scale } = typography

export { rhythm, scale, typography as default }
